<!-- eslint-disable no-mixed-spaces-and-tabs -->
<template>
	<div>
		<div class="header" :class="{'header-fixed': scroll, 'header-transparent dark': transparent,'header-light head-shadow': !transparent}">
			<div class="container">
				<nav id="navigation"  :class="windowWidth > 991 ? 'navigation navigation-landscape' : 'navigation navigation-portrait'"
					:dir="$i18n.locale == 'ar'? 'rtl':'ltr'" >
					<div class="nav-header">
						<router-link to="" class="nav-brand text-logo" >
							<span class="svg-icon text-primary svg-icon-2hx">
								<img :src="windowWidth > 991 ? logoLight : mobileLight">
							</span>
						</router-link>
						<div class="nav-toggle" :style="{ 
							left: $i18n.locale === 'ar' ? '0' : 'auto',
							right: $i18n.locale === 'ar' ? 'auto' : '0'
						}" @click="toggle = !toggle"></div>
						<div class="mobile_nav">
						</div>
					</div>
					<div class="nav-menus-wrapper nav-menus-wrapper-open" :class="{ 'nav-menus-wrapper-open': toggle}"  :style="{
						'left': toggle ? ($i18n.locale === 'ar' ? 'auto' : '0%') : ($i18n.locale === 'ar' ? '100%' : '-100%'),
						'right': $i18n.locale === 'ar' ? (toggle ? '0%' : '-100%') : 'auto'
						}">
						<span class="nav-menus-wrapper-close-button" @click="toggle = !toggle">✕</span>
						<ul class="nav-menu" :style="{ float: $i18n.locale === 'ar' ? 'right' : 'left' }">
							<li>
								<router-link to="/" class="d-flex align-items-center">{{ $t('Home') }}</router-link>
							</li>
							<li>
								<router-link to="/about-us" class="d-flex align-items-center">{{ $t('About') }}</router-link>
							</li>
							<li>
								<router-link to="/contact" class="d-flex align-items-center">{{ $t('Contact Us') }}</router-link>
							</li>
							<li>
								<router-link to="/grid" class="d-flex align-items-center">{{ $t('Explore All Providers') }}</router-link>
							</li>
							<li>
								<router-link to="/privacy-page" class="d-flex align-items-center">{{ $t('Privacy Policy') }}</router-link>
							</li>
							<li>
								<router-link to="/term-condition" class="d-flex align-items-center">{{ $t('Terms and Conditions') }}</router-link>
							</li>
							<!-- <li :class="{active: ['/single-property-1','/single-property-2','/single-property-3','/single-property-4','/agencies','/agency-page','/agents','/agent-page','/add-agent','/edit-agent','/dashboard','/payment','/my-profile','/create-account','/checkout','/my-property','/bookmark-list','/change-password','/submit-property-dashboard','/submit-property','/compare-property'].includes(current),show: activeMenu['index-page'] && activeMenu['index-page']['main']}" @mouseenter="handleMouseEnter('feature-page')" @mouseleave="handleMouseLeave('feature-page')"><router-link to="" class="d-flex align-items-center">Features<span class="submenu-indicator"><span class="submenu-indicator-chevron"></span></span></router-link>
								<ul class="nav-dropdown nav-submenu" :style="{display: activeMenu['feature-page'] && activeMenu['feature-page']['main'] ? 'block' : 'none', pointerEvents: activeMenu['feature-page'] && activeMenu['feature-page']['main'] ? 'auto' : 'none'}">

									<li :class="{active: ['/single-property-1','/single-property-2','/single-property-3','/single-property-4',].includes(current),show: activeMenu['index-page'] && activeMenu['index-page']['main']}" @mouseenter="handleMouseEnter('detail-page')" @mouseleave="handleMouseLeave('detail-page')"><router-link to="" class="d-flex align-items-center justify-content-between">Single Property<span class="submenu-indicator"><span class="submenu-indicator-chevron"></span></span></router-link>
										<ul class="nav-dropdown nav-submenu" :style="{display: activeMenu['detail-page'] && activeMenu['detail-page']['main'] ? 'block' : 'none', pointerEvents: activeMenu['detail-page'] && activeMenu['detail-page']['main'] ? 'auto' : 'none'}">
											<li><router-link to="/single-property-1" :class="current === '/single-property-1' ? 'active' : ''">Single Property 1</router-link></li>                                    
											<li><router-link to="/single-property-2" :class="current === '/single-property-2' ? 'active' : ''">Single Property 2</router-link></li>                                    
											<li><router-link to="/single-property-3" :class="current === '/single-property-3' ? 'active' : ''">Single Property 3</router-link></li> 
											<li><router-link to="/single-property-4" :class="current === '/single-property-4' ? 'active' : ''">Single Property 4</router-link></li> 												
										</ul>
									</li>

									<li :class="{active: ['/agencies','/agency-page'].includes(current),show: activeMenu['index-page'] && activeMenu['index-page']['main']}" @mouseenter="handleMouseEnter('agencies-page')" @mouseleave="handleMouseLeave('agencies-page')"><router-link to="" class="d-flex align-items-center justify-content-between">Agencies<span class="submenu-indicator"><span class="submenu-indicator-chevron"></span></span></router-link>
										<ul class="nav-dropdown nav-submenu" :style="{display: activeMenu['agencies-page'] && activeMenu['agencies-page']['main'] ? 'block' : 'none', pointerEvents: activeMenu['agencies-page'] && activeMenu['agencies-page']['main'] ? 'auto' : 'none'}">                                  
											<li><router-link to="/agencies" :class="current === '/agencies' ? 'active' : ''">Agencies List</router-link></li>                                    
											<li><router-link to="/agency-page" :class="current === '/agency-page' ? 'active' : ''">Agency Page</router-link></li> 
										</ul>
									</li>

									<li :class="{active: ['/agents','/agent-page','/add-agent','/edit-agent',].includes(current),show: activeMenu['index-page'] && activeMenu['index-page']['main']}" @mouseenter="handleMouseEnter('agents-page')" @mouseleave="handleMouseLeave('agents-page')"><router-link to="" class="d-flex align-items-center justify-content-between">Agents<span class="submenu-indicator"><span class="submenu-indicator-chevron"></span></span></router-link>
										<ul class="nav-dropdown nav-submenu" :style="{display: activeMenu['agents-page'] && activeMenu['agents-page']['main'] ? 'block' : 'none', pointerEvents: activeMenu['agents-page'] && activeMenu['agents-page']['main'] ? 'auto' : 'none'}">
											<li><router-link to="/agents" :class="current === '/agents' ? 'active' : ''">Agents List</router-link></li>                                    
											<li><router-link to="/agent-page" :class="current === '/agent-page' ? 'active' : ''">Agent Page</router-link></li>
											<li><router-link to="/add-agent" :class="current === '/add-agent' ? 'active' : ''">Add Agent</router-link></li>
											<li><router-link to="/edit-agent" :class="current === '/edit-agent' ? 'active' : ''">Edit Agent</router-link></li>
										</ul>
									</li>
									<li :class="{active: ['/payment','/my-profile','/create-account','/login-page','/checkout','/my-property','/bookmark-list','/change-password','/submit-property-dashboard'].includes(current),show: activeMenu['index-page'] && activeMenu['index-page']['main']}" @mouseenter="handleMouseEnter('admin-page')" @mouseleave="handleMouseLeave('admin-page')"><router-link to="" class="d-flex align-items-center justify-content-between">My Account<span class="submenu-indicator"><span class="submenu-indicator-chevron"></span></span></router-link>
										<ul class="nav-dropdown nav-submenu" :style="{display: activeMenu['admin-page'] && activeMenu['admin-page']['main'] ? 'block' : 'none', pointerEvents: activeMenu['admin-page'] && activeMenu['admin-page']['main'] ? 'auto' : 'none'}">
											<li><router-link to="/payment" :class="current === '/payment' ? 'active' : ''">Payment Confirmation</router-link></li>
											<li v-if="isLoggedIn">
											<a href="javascript:void(0)" @click="goToProfile" :class="current.startsWith('/dashboard') || current.startsWith('/user_dashboard') ? 'active' : ''">
												{{ $t('Profile') }}
											</a>
											</li>                                     
											<li><router-link to="/create-account" :class="current === '/create-account' ? 'active' : ''">{{$t('Create An Account')}}</router-link></li>                                    
											<li><router-link to="/login-page" :class="current === '/login-page' ? 'active' : ''">{{$t('Login')}}</router-link></li>                                                                        
											<li><router-link to="/checkout" :class="current === '/checkout' ? 'active' : ''">Checkout</router-link></li>                                    
											<li><router-link to="/my-property" :class="current === '/my-property' ? 'active' : ''">Property List</router-link></li>                                    
											<li><router-link to="/bookmark-list" :class="current === '/bookmark-list' ? 'active' : ''">Bookmarked Listings</router-link></li>                                    
											<li v-if="isLoggedIn"><router-link to="/change-password" :class="current === '/change-password' ? 'active' : ''">{{$t('Change Password')}}</router-link></li>
											<li><router-link to="/submit-property-dashboard" :class="current === '/submit-property-dashboard' ? 'active' : ''">Submit Property Dashboard</router-link></li> 
										</ul>
									</li>
									<li>
										<router-link to="/compare-property" :class="current === '/compare-property' ? 'active' : ''">Compare Property</router-link>                                
									</li>
									<li>
										<router-link to="/submit-property" :class="current === '/submit-property' ? 'active' : ''">Submit Property</router-link>                                
									</li>
								</ul>
							</li> -->
							<!-- Language Switcher inside the nav menu -->
							<li class="locale-changer">
								<div class="custom-dropdown" @click="toggleDropdown = !toggleDropdown" ref="dropdownRef">
								<div class="selected">
									<img :src="selectedFlag" alt="flag" />
									<span class="lang-name">{{ getLangName(locale) }}</span>
								</div>
								<ul v-if="toggleDropdown" class="dropdown-list">
									<li v-for="(locale, index) in availableLocales" :key="index" @click="changeLocale(locale)" class="dropdown-item">
									<div class="flag-container">
										<img :src="getFlag(locale)" alt="flag" class="flag-circle" />
										<span class="lang-name">{{ getLangName(locale) }}</span>
									</div>
									</li>
								</ul>
								</div>
							</li>
						</ul>
					</div>
					<ul class="nav-menu nav-menu-social align-to-right">
						<li v-if="isLoggedIn">
							<a href="javascript:void(0)" @click="goToProfile" :class="current.startsWith('/dashboard') || current.startsWith('/user_dashboard') ? 'active' : ''">
								{{ userName  }}
							</a>
						</li> 
						<li  v-else>
							<router-link to="#" data-bs-toggle="modal" data-bs-target="#login" class="fw-medium text-muted-2">
								<span class="svg-icon svg-icon-2hx me-1">
									<svg width="22" height="22" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path opacity="0.3" d="M16.5 9C16.5 13.125 13.125 16.5 9 16.5C4.875 16.5 1.5 13.125 1.5 9C1.5 4.875 4.875 1.5 9 1.5C13.125 1.5 16.5 4.875 16.5 9Z" fill="currentColor"/>
										<path d="M9 16.5C10.95 16.5 12.75 15.75 14.025 14.55C13.425 12.675 11.4 11.25 9 11.25C6.6 11.25 4.57499 12.675 3.97499 14.55C5.24999 15.75 7.05 16.5 9 16.5Z" fill="currentColor"/>
										<rect x="7" y="6" width="4" height="4" rx="2" fill="currentColor"/>
									</svg>
								</span>
								{{ $t('SignUp or SignIn') }}
							</router-link>
						</li>
						
						<li class="add-listing light">
							<router-link to="/contact" class="bg-primary">
								<span class="svg-icon svg-icon-muted svg-icon-2hx me-1">
									<svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect opacity="0.3" width="12" height="2" rx="1" transform="matrix(-1 0 0 1 15.5 11)" fill="currentColor"/>
										<path d="M13.6313 11.6927L11.8756 10.2297C11.4054 9.83785 11.3732 9.12683 11.806 8.69401C12.1957 8.3043 12.8216 8.28591 13.2336 8.65206L16.1592 11.2526C16.6067 11.6504 16.6067 12.3496 16.1592 12.7474L13.2336 15.3479C12.8216 15.7141 12.1957 15.6957 11.806 15.306C11.3732 14.8732 11.4054 14.1621 11.8756 13.7703L13.6313 12.3073C13.8232 12.1474 13.8232 11.8526 13.6313 11.6927Z" fill="currentColor"/>
										<path d="M8 5V6C8 6.55228 8.44772 7 9 7C9.55228 7 10 6.55228 10 6C10 5.44772 10.4477 5 11 5H18C18.5523 5 19 5.44772 19 6V18C19 18.5523 18.5523 19 18 19H11C10.4477 19 10 18.5523 10 18C10 17.4477 9.55228 17 9 17C8.44772 17 8 17.4477 8 18V19C8 20.1046 8.89543 21 10 21H19C20.1046 21 21 20.1046 21 19V5C21 3.89543 20.1046 3 19 3H10C8.89543 3 8 3.89543 8 5Z" fill="currentColor"/>
									</svg>
								</span>{{ $t('contact us') }}
							</router-link>
						</li>
						<!-- <li>
							<router-link to="#" class="text-invers" data-bs-toggle="offcanvas" data-bs-target="#offcanvasScrolling" aria-controls="offcanvasScrolling">
								<span class="svg-icon svg-icon-2hx">
									<svg width="24" height="24" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
										<rect y="6" width="16" height="3" rx="1.5" fill="currentColor"/>
										<rect opacity="0.3" y="12" width="8" height="3" rx="1.5" fill="currentColor"/>
										<rect opacity="0.3" width="12" height="3" rx="1.5" fill="currentColor"/>
									</svg>
								</span>
							</router-link>
						</li> -->
					</ul>
				</nav>
			</div>
		</div>

		<div class="clearfix"></div>
				<div class="offcanvas offcanvas-end" data-bs-scroll="true" data-bs-backdrop="false" tabindex="-1" id="offcanvasScrolling" aria-labelledby="offcanvasScrollingLabel">
			<div class="offcanvas-header">
				<h5 class="offcanvas-title" id="offcanvasScrollingLabel">Compare & Selected Property</h5>
				<router-link to="#" data-bs-dismiss="offcanvas" aria-label="Close">
					<span class="svg-icon text-primary svg-icon-2hx">
						<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
							<rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>
							<rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/>
							<rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/>
						</svg>
					</span>
				</router-link>
			</div>
			<div class="offcanvas-body">
				<ul class="nav nav-pills sider_tab mb-3" id="pills-tab" role="tablist">
					<li class="nav-item" role="presentation">
						<button class="nav-link active" id="pills-compare-tab" data-bs-toggle="pill" data-bs-target="#pills-compare" type="button" role="tab" aria-controls="pills-compare" aria-selected="true">Compare Property</button>
					</li>
					<li class="nav-item" role="presentation">
						<button class="nav-link" id="pills-saved-tab" data-bs-toggle="pill" data-bs-target="#pills-saved" type="button" role="tab" aria-controls="pills-saved" aria-selected="false">Saved Property</button>
					</li>
				</ul>
				<div class="tab-content" id="pills-tabContent">
					<div class="tab-pane fade show active" id="pills-compare" role="tabpanel" aria-labelledby="pills-compare-tab" tabindex="0">
						<div class="sidebar_featured_property">
							<div v-for="(item, index) in navProperty" :key="index" class="sides_list_property p-2">
								<div class="sides_list_property_thumb">
									<img :src="item.image" class="img-fluid" alt="">
								</div>
								<div class="sides_list_property_detail">
									<h4><router-link to="/single-property-1">{{item.name}}</router-link></h4>
									<span class="text-muted-2"><i class="fa-solid fa-location-dot"></i>{{item.loction}}</span>
									<div class="lists_property_price">
										<div class="lists_property_types">
											<div v-if="item.type === 'For Sale'" class="property_types_vlix sale">For Sale</div>
											<div v-if="item.type === 'For Rent'" class="property_types_vlix">For Rent</div>
											<div v-if="item.type === 'For Buy'" class="property_types_vlix buy">For Buy</div>
										</div>
										<div class="lists_property_price_value">
											<h4 class="text-primary">$4,240</h4>
										</div>
									</div>
								</div>
							</div>
							
							<div class="input-group">
								<router-link to="/compare-property" class="btn btn-light-primary fw-medium full-width">View & Compare</router-link>
							</div>
						</div>	
					</div>
					<div class="tab-pane fade" id="pills-saved" role="tabpanel" aria-labelledby="pills-saved-tab" tabindex="0">
						<div class="sidebar_featured_property">
									
							<div v-for="(item, index) in navProperty2" :key="index" class="sides_list_property p-2">
								<div class="sides_list_property_thumb">
									<img :src="item.image" class="img-fluid" alt="">
								</div>
								<div class="sides_list_property_detail">
									<h4><router-link to="/single-property-1">{{item.name}}</router-link></h4>
									<span class="text-muted-2"><i class="fa-solid fa-location-dot"></i>{{item.loction}}</span>
									<div class="lists_property_price">
										<div class="lists_property_types">
											<div v-if="item.type === 'For Sale'" class="property_types_vlix sale">For Sale</div>
											<div v-if="item.type === 'For Rent'" class="property_types_vlix">For Rent</div>
											<div v-if="item.type === 'For Buy'" class="property_types_vlix buy">For Buy</div>
										</div>
										<div class="lists_property_price_value">
											<h4 class="text-primary">$4,240</h4>
										</div>
									</div>
								</div>
							</div>
							<div class="input-group">
								<router-link to="#" class="btn btn-light-primary fw-medium full-width">View & Compare</router-link>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div :dir="$i18n.locale === 'ar' ? 'rtl' : 'ltr'">
			<div class="modal fade" id="login" tabindex="-1" role="dialog" aria-labelledby="registermodal" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered login-pop-form" role="document">
					<div class="modal-content" id="registermodal">
						<span class="mod-close" data-bs-dismiss="modal" aria-hidden="true">
							<span class="svg-icon text-primary svg-icon-2hx">
								<svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<rect opacity="0.3" x="2" y="2" width="20" height="20" rx="10" fill="currentColor"/>
									<rect x="7" y="15.3137" width="12" height="2" rx="1" transform="rotate(-45 7 15.3137)" fill="currentColor"/>
									<rect x="8.41422" y="7" width="12" height="2" rx="1" transform="rotate(45 8.41422 7)" fill="currentColor"/>
								</svg>
							</span>
						</span>
						<div class="modal-body">
							<h4 class="modal-header-title">{{$t('Log In')}}</h4>
							<div class="d-flex align-items-center justify-content-center mb-3">
								<img :src="mobileLight" alt="">
							</div>
							<div class="login-form">
								<form @submit="submitLogin">
								
									<div class="form-floating mb-3">
										<input type="text" v-model="phone_or_email" class="form-control" :placeholder="$t('Email Or Phone')">
										<label>{{$t('Email Or Phone')}}-{{$t('If Phone Please Add Country Code (+963965***)')}}</label>
									</div>
									
									<div class="form-floating mb-3">
										<input type="password" v-model="password" class="form-control" placeholder="******">
											<!-- eslint-disable-next-line no-mixed-spaces-and-tabs -->
										<label>{{$t('Password')}}</label>
									</div>
									
									<div class="form-group mb-3">
										<div class="d-flex align-items-center justify-content-between">
											<div class="flex-shrink-0 flex-first">
												<div class="form-check form-check-inline">
													<input class="form-check-input" type="checkbox" id="save-pass" value="option1">
													<label class="form-check-label" for="save-pass">{{$t('Save Password')}}</label>
												</div>	
											</div>
											<div class="flex-shrink-0 flex-first">
												<p class="mt-4">
													<a href="/change-password" @click="closeModal" class="link fw-medium">
													{{$t('Forgot Password?')}}
													</a>
												</p>
											</div>
										</div>
									</div>
									
									<div class="form-group">
									<button type="submit" class="btn btn-lg btn-primary fw-medium full-width rounded-2">
									{{$t('Log In')}}
									</button>
								</div>
								</form>
							</div>
							<!-- <div class="modal-divider"><span>Or login via</span></div>
							<div class="social-login mb-3">
								<ul>
									<li><router-link to="" class="btn connect-fb"><i class="ti ti-facebook"></i>Facebook</router-link></li>
									<li><router-link to="" class="btn connect-google"><i class="ti ti-google"></i>Google+</router-link></li>
								</ul>
							</div> -->
							<div class="text-center">
								<p class="mt-4">
									{{$t("Have't Any Account?")}} 
									<a href="/create-account" @click="closeModal" class="link fw-medium">
									{{$t('Create An Account')}}
									</a>
								</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, defineProps, computed } from 'vue';
// import add from '@/assets/img/svg/add.svg';
// import bar from '@/assets/img/svg/bar.svg';
import axios from 'axios'
import logoLight from '@/assets/img/svg/Logo-g.webp'
import mobileLight from '@/assets/img/svg/logo-dash.png'
import trflag from '@/assets/img/svg/tr.png';
import enflag from '@/assets/img/svg/en.png';
import arflag from '@/assets/img/svg/sy.svg';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useToast } from "vue-toastification"
import { useRouter } from 'vue-router';
const { t } = useI18n()
const toggle = ref(false);
const windowWidth = ref(window.innerWidth);
const scroll = ref(false);
const toggleDropdown = ref(false);
const availableLocales = ['en', 'ar','tr'];
const selectedFlag = ref('');
const dropdownRef = ref(null);
const handleResize = () => {
  windowWidth.value = window.innerWidth;
};

const handleScroll = () => {
  scroll.value = window.scrollY >= 50;
};

onMounted(() => {
  window.scrollTo(0, 0);
  window.addEventListener('resize', handleResize);
  window.addEventListener('scroll', handleScroll);

  const { locale } = useI18n();
  selectedFlag.value = getFlag(locale.value);
  document.addEventListener('click', closeDropdownOnClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', closeDropdownOnClickOutside);
});

const { locale } = useI18n();
const changeLocale = (localeValue) => {
  locale.value = localeValue;
  localStorage.setItem('locale', locale.value);
  selectedFlag.value = getFlag(localeValue);
  toggleDropdown.value = false; 
//   window.location.reload(); 
};

const closeDropdownOnClickOutside = (event) => {
  if (dropdownRef.value && !dropdownRef.value.contains(event.target)) {
    toggleDropdown.value = false;
  }
};

const getFlag = (locale) => {
  if (locale === 'ar') return arflag;
  if (locale === 'tr') return trflag;
  return enflag;
};
defineProps({
	transparent:Boolean
})

// const activeMenu = ref({});
const router = useRoute();
const current = ref(router.path);
onMounted(()=>{
	window.scrollTo(0,0)
	window.addEventListener('resize', handleResize);
	window.addEventListener('scroll', handleScroll);
})

// const handleMouseEnter = (menu, submenu = 'main') => {
// 	if (!activeMenu.value[menu]) {
// 		activeMenu.value[menu] = {};
// 	}
// 	activeMenu.value[menu][submenu] = true;
// };

// const handleMouseLeave = (menu, submenu = 'main') => {
// 	if (activeMenu.value[menu]) {
// 		activeMenu.value[menu][submenu] = false;
// 	}
// };

const route = useRouter();
const phone_or_email = ref('')
const password = ref('')
const toast = useToast()
const userName = ref('');
const savedName = localStorage.getItem('user_name');
if (savedName) {
  userName.value = savedName;
}
const submitLogin = async (e) => {
  e.preventDefault()

  const formData = new FormData()
  formData.append('phone_or_email', phone_or_email.value)
  formData.append('password', password.value)

  try {
    const response = await axios.post('/login', formData)
	if (response.data.msg == "حسابك غير مفعل") {
      toast.error(response.data.msg, {
        timeout: 5000,
        closeOnClick: true,
        pauseOnHover: true,
      });
      return;
    }
    const userId = response.data.user_id
    const token = response.data.token
    const userRole = response.data.user_role;
    localStorage.setItem('auth_token', token) 
	localStorage.setItem('user_type', userRole);
	localStorage.setItem('user_name', response.data.user_name);    
    console.log('Login successful:', response.data)
    
	if (userRole === 'Service Provider') {
	route.push(`/dashboard/${userId}`).then(() => {
		location.reload();
	});
	} else {
	route.push(`/user_dashboard/${userId}`).then(() => {
		location.reload();
	});
	}
  }   catch (error) {
    const status = error.response?.status
    let errorMessage

    if (status === 422) {
      errorMessage = t('Your account is not activated') 
    } else if (status === 404) {
      errorMessage = t('Your account has been deleted')
    } else {
      errorMessage = error.response?.data?.msg || t('Login failed. Please try again.')
    }

    console.error('Login error:', errorMessage)
    toast.error(errorMessage)
  }
}
const isLoggedIn = computed(() => {
  return !!localStorage.getItem('auth_token');
});
const token = localStorage.getItem('auth_token');
const userRole = localStorage.getItem('user_type');
const userId = localStorage.getItem('user_id');

const goToProfile = () => {
  if (!token) {
    route.push('/login-page');
  } else if (userRole === 'Service Provider') {
    route.push(`/dashboard/${userId}`);
  } else {
    route.push(`/user_dashboard/${userId}`);
  }
};
const getLangName = (locale) => {
  if (locale === 'ar') return 'Ar';
  if (locale === 'tr') return 'Tr';
  return 'En';
};

</script>

<style scoped>
.locale-changer {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 15px;
  margin-top: 1%;
}

.custom-dropdown {
  position: relative;
  cursor: pointer;
}

.selected {
  display: flex;
  align-items: center;
  padding: 5px 10px;
}

.selected img {
  width: 68px;
  height: 35px;
  margin-right: 10px;
}

.dropdown-list {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  list-style: none;
  padding: 0;
  margin: 0;
  z-index: 10;
  max-height: 200px;
  overflow-y: auto;
}

.dropdown-item {
  display: flex;
  align-items: center;
  padding: 10px;
  /* transition: background-color 0.3s ease; */
  background-color: white;
}

.dropdown-item:hover {
  cursor: pointer;
  background-color: #f1f1f1;
}

/* Style for flag container */
.flag-container {
  display: flex;
  align-items: center;
}

.flag-circle {
  width: 30px;
  height: 30px;
  /* border-radius: 50%; */
  margin-right: 10px;
}
.flag-container .lang-name{
  font-size: 14px;
  color:#2c3f56;
}
.lang-name {
  font-size: 14px;
  color: white;
}

.selected {
  display: flex;
  align-items: center;
  padding: 5px 10px;
}

.selected img {
  width: 30px;
  height: 30px;
  /* border-radius: 50%;  */
  margin-right: 10px;
}

</style>
